// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"501":"9f20f1a0","508":"454b1bf3","875":"59b0aa6a","901":"cba3cc4b"}[chunkId] + ".css";
};